module.exports = __webpack_public_path__ + "static/media/Colette Curve King Headboard - 180 cm_Blush Pink.89dcc67d.png";